import 'modules/intro-headline/intro-headline';
import 'modules/river-flow/river-flow';
import 'modules/working-with-us/working-with-us';
import BlockquoteCarousel from 'modules/blockquote-carousel/blockquote-carousel';
import 'modules/logo-garden/logo-garden';
import 'modules/mega-contact-link/mega-contact-link';
import 'modules/mega-link/mega-link';
import 'modules/awards/awards';
import './index.scss';

BlockquoteCarousel.initializeAll();
